module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_fails.js
// module id = ../../../../core-js/library/modules/_fails.js
// module chunks = 7